import { Button, Drawer, Progress, message } from "antd";
import { useForm } from "react-hook-form";
import { Flex, Input, Typography } from "antd";
import { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import { Alert } from "antd";
import toast from "react-hot-toast";
// import layerimage from '././../../Assets/Icons/layer.jpeg'
import layerimage from "././../../Assets/Icons/layer-bg.png";

const LoginWithOtp = () => {
  const [otp, setOtp] = useState("");
  const [isprogress, setProgress] = useState(false);
  const navigate = useNavigate();
  const currentUser = localStorage.getItem("candidate");
  // const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const [logo, setLogo] = useState();

  const {
    register,
    control,
    setError,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      is_employee_login_as_candidate: true,
    },
  });
  const onChange = (code) => {
    setOtp(code);
  };
  const sharedProps = {
    onChange,
  };
  const sendOtp = async () => {
    setProgress(true);
    var data = {
      otp: otp,
    };

    await AuthService.verifyOtp(data)
      .then(
        (oResponse) => {
          localStorage.setItem(
            "candidate",
            JSON.stringify(oResponse.data.data)
          );
          const authData = oResponse.data.data;
          toast.success("OTP Verified");
          navigate("/");
          setProgress(false);
        },
        (error) => {
          const errorMessage = error.response.data.error_info.otp;
          toast.error(errorMessage);
          setProgress(false);
        }
      )
      .catch((err) => {
        console.log(err);
        setProgress(false);
      });
  };

  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };
  useEffect(() => {
    getLogo();
  }, []);
  return (
    <div className="flex w-full flex-col md:flex-row lg:flex-row min:h-full pb-10 md:pb-0">
      
      {/* <section
        className="relative flex flex-col md:flex md:w-[40%] md:h-screen h-full justify-center items-center p-6 md:p-8 bg-gradient-to-b from-[#F9FFF3] to-[#F9FFF3] 
    overflow-y-auto md:overflow-visible max-h-screen"
      >

        <div>
          <img
            src={layerimage}
            alt="Illustration"
            className="w-4/4 max-w-xs md:max-w-lg mb-6 md:mb-0"
          />
        </div>

        <div className="text-center md:text-left mt-4 md:mt-12">
          <p className="text-xl md:text-2xl font-bold text-[#00175e]">
            Land your Dream Job
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#00175e] mt-2 md:mt-3">
            Book Your AI Interview
          </h2>
        </div>
      </section> */}

      <section className="w-full md:w-[60%] flex flex-col bg-white px-8 gap-4 mt-6">
        <div className="pageContent scrollbar-hide flex ">
          <div className="w-full chart_div">
            <div className="w-[90%] md:w-[75%] flex flex-col gap-10 mt-6 md:mt-0 sm:mt-0">
              <p className="text-3xl md:text-5xl font-semibold px-0 md:px-12 lg:px-14">
                Sign In
              </p>

              {/* OTP Input */}
              <div className="px-0 md:px-14 lg:px-14 pb-14">
                <div className="w-[100%] md:w-[75%] lg:w-[75%] flex flex-col">
                  <label className="mb-6 font-semibold text-lg">OTP</label>
                  <div>
                    <Input.OTP {...sharedProps} />
                  </div>
                  <div>
                    <button
                      className="bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg mt-10"
                      type="button"
                      onClick={() => sendOtp()}
                    >
                      Sign In
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-[100%] md:w-[85%] lg:w-[85%] px-[3rem]">
              <hr
                style={{
                  width: "100%",
                  border: "none",
                  borderTop: "1px solid #B8B8B8",
                  margin: 0,
                }}
              />
              <div className="flex items-center gap-3 mt-4">
                <p className="text-[#000] font-sans">Don’t have an account?</p>
                <Link
                  to="/signup"
                  className="text-[#0071DC] font-sans text-lg font-semibold cursor-pointer"
                >
                  Sign Up Now
                </Link>
              </div>
            </div>
            </div>
            
          </div>
        </div>
      </section>
      <section
        className="relative flex flex-col md:flex  md:w-[40%] md:h-screen h-full justify-center  items-center p-6 md:p-8"
        style={{
          background: "#F3FCF4",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Top Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        {/* Bottom Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        <div className="">
          <img
            src={layerimage}
            alt="Illustration"
            className="w-4/4 max-w-xs md:max-w-lg mb-6 md:mb-0 "
          />
        </div>

        {/* Text Content */}
        <div className="text-center md:text-left mt-4 md:mt-12">
          <p className="text-xl md:text-2xl font-bold text-[#00175e]">
            Land your Dream Job
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#00175e] mt-2 md:mt-3">
            Book Your AI Interview
          </h2>
        </div>
      </section>
    </div>
  );
};
export default LoginWithOtp;
